import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import { version, name } from '../package.json'
import {
  pessoasDao,
  administradorDao,
  comprasDao,
  clientesDao,
  combustivelDao,
  bandeiraDao,
  faqDao,
  postoDao,
  formasPagDao,
  tiposPagDao,
  versionamentoDao,
  tiposVeiculoDao,
  automacoesDao,
  termosDeUsoDao,
  politicasDePrivacidadeDao,
  pagamentosExtraDao,
  faturamentosDao,
  notificacaoDao,
  empresaDao,
  convenioDao,
  cartaoDao,
  codigosPromocionaisDao,
  redeDao,
  voucherDao,
  carteiraVirtualDao,
  propostaDao,
  configuracoesDao,
  veiculoDao,
  funcionarioDao,
  solicitacaoDao,
  frentistaDao,
  coordenadas,
  anuncioDao,
  categoriaDao,
  firebaseDao,
  bandeiraCartaoDao,
  integradorDao,
  leilaoDao,
  precoCombustivelDao,
  sendzapiDao,
  taxasChecktudoDao,
  assinaturaDao,
  pedidoDao,
  redeEmpresaDao
} from '@/api'

Vue.use(Vuex)

// TODO: Colocar a pessoa como filho do usuario e o endereco como filho da pessoa
export default new Vuex.Store({
  state: {
    user: null,
    pessoa: null,
    combustiveis: [],
    combustivel: null,
    postos: [],
    totalItemsPostos: null,
    compras: [],
    formaPagamento: null,
    formasPag: [],
    totalItemsFormasPag: null,
    tiposPag: [],
    tipoPag: null,
    usuarios: [],
    pendingUsers: [],
    faturamentos: [],
    usuariosApetrus: [],
    totalItemsUsuarios: null,
    totalItemsEmpresas: null,
    totalItemsConvenios: null,
    paginationUsuarios: {},
    bandeiras: [],
    totalItemsBandeiras: null,
    tiposVeiculo: [],
    faqs: [],
    faq: null,
    totalItemsFaqs: null,
    versoes: [],
    versao: null,
    endereco: null,
    fotoPerfil: null,
    loading: false,
    error: null,
    headers: null,
    authenticated: null,
    lastPage: null,
    automacoes: [],
    termosDeUso: [],
    politicasDePrivacidade: [],
    termoSelected: null,
    politicaSelected: null,
    pagamentosExtra: [],
    interval: 0,
    timer: 0,
    smartLock: false,
    verificationId: null,
    appVerifier: null,
    hasNewVersion: false,
    versaoApp: localStorage.getItem(`apetrus-administradores-versao`),
    naologar: false,
    empresas: [],
    convenios: [],
    pagamentosSecundarios: [],
    estados: [
      { value: 'AC', text: 'Acre' },
      { value: 'AL', text: 'Alagoas' },
      { value: 'AP', text: 'Amapá' },
      { value: 'AM', text: 'Amazonas' },
      { value: 'BA', text: 'Bahia' },
      { value: 'CE', text: 'Ceará' },
      { value: 'DF', text: 'Distrito Federal' },
      { value: 'ES', text: 'Espírito Santo' },
      { value: 'GO', text: 'Goiás' },
      { value: 'MA', text: 'Maranhão' },
      { value: 'MT', text: 'Mato Grosso' },
      { value: 'MS', text: 'Mato Grosso do Sul' },
      { value: 'MG', text: 'Minas Gerais' },
      { value: 'PA', text: 'Pará' },
      { value: 'PB', text: 'Paraíba' },
      { value: 'PR', text: 'Paraná' },
      { value: 'PE', text: 'Pernambuco' },
      { value: 'PI', text: 'Piauí' },
      { value: 'RJ', text: 'Rio de Janeiro' },
      { value: 'RN', text: 'Rio Grande do Norte' },
      { value: 'RS', text: 'Rio Grande do Sul' },
      { value: 'RO', text: 'Rondônia' },
      { value: 'RR', text: 'Roraima' },
      { value: 'SC', text: 'Santa Catarina' },
      { value: 'SP', text: 'São Paulo' },
      { value: 'SE', text: 'Sergipe' },
      { value: 'TO', text: 'Tocantins' }
    ]
  },
  mutations: {
    setAuthHeader (state, payload) {
      state.headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${payload}`,
        'X-App-Name': name,
        'X-App-Version': version
      })
    },
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setPessoa (state, payload) {
      state.pessoa = payload
    },
    setUserImage (state, payload) {
      state.user.image = payload
    },
    setEndereco (state, payload) {
      state.endereco = payload
    },
    setFotoPerfil (state, payload) {
      state.fotoPerfil = payload
    },
    setPostos (state, payload) {
      state.postos = payload
    },
    setTotalItemsPostos (state, payload) {
      state.totalItemsPostos = payload
    },
    setUsuarios (state, payload) {
      state.usuarios = payload
    },
    setCompras (state, payload) {
      state.compras = payload
    },
    setUsuariosApetrus (state, payload) {
      state.usuariosApetrus = payload
    },
    setPaginationUsuarios (state, payload) {
      state.paginationUsuarios = payload
    },
    setTotalItemsUsuarios (state, payload) {
      state.totalItemsUsuarios = payload
    },
    setBandeiras (state, payload) {
      state.bandeiras = payload
    },
    setTiposVeiculo (state, payload) {
      state.tiposVeiculo = payload
    },
    setTotalItemsBandeiras (state, payload) {
      state.totalItemsBandeiras = payload
    },
    setFaqs (state, payload) {
      state.faqs = payload
    },
    setFaq (state, payload) {
      state.faq = payload
    },
    setTotalItemsFaqs (state, payload) {
      state.totalItemsFaqs = payload
    },
    setFormaPagamento (state, payload) {
      state.formaPagamento = payload
    },
    setFormasPag (state, payload) {
      state.formasPag = payload
    },
    setTiposPagamento (state, payload) {
      state.tiposPag = payload
    },
    setTipoPagamento (state, payload) {
      state.tipoPag = payload
    },
    setTotalItemsFormasPag (state, payload) {
      state.totalItemsFormasPag = payload
    },
    setVersoes (state, payload) {
      state.versoes = payload
    },
    setVersao (state, payload) {
      state.versao = payload
    },
    clearError (state) {
      state.error = null
    },
    setCombustiveis (state, payload) {
      state.combustiveis = payload
    },
    setCombustivel (state, payload) {
      state.combustivel = payload
    },
    insertPosto (state, payload) {
      state.postos.push(payload)
    },
    setAuthenticated (state, payload) {
      state.authenticated = payload
    },
    setAutomacoes (state, payload) {
      state.automacoes = payload
    },
    setLastPage (state, payload) {
      if (state.user) {
        localStorage.setItem(`admin-${state.user.id}`, payload)
      }
      state.lastPage = payload
    },
    setTermosDeUso (state, payload) {
      state.termosDeUso = payload
    },
    setTermoSelected (state, payload) {
      state.termoSelected = payload
    },
    setPoliticaSelected (state, payload) {
      state.politicaSelected = payload
    },
    setPoliticasDePrivacidade (state, payload) {
      state.politicasDePrivacidade = payload
    },
    setPagamentosExtra (state, payload) {
      state.pagamentosExtra = payload
    },
    setFaturamentos (state, payload) {
      state.faturamentos = payload
    },
    setPending (state, payload) {
      state.pendingUsers = payload
    },
    updatePendingUser (state, payload) {
      state.pendingUsers.splice(payload.index, 1, payload.user)
    },
    clearTimer (state) {
      state.smartLock = false
      state.timer = 0
    },
    decreaseTimer (state, payload) {
      state.timer -= payload
      if (state.timer <= 0) {
        state.timer = 0
        state.smartLock = false
      }
    },
    setTimer (state, payload) {
      state.smartLock = true
      state.timer = payload
    },
    setVerificationId (state, payload) {
      state.verificationId = payload
    },
    setAppVerifier (state, payload) {
      state.appVerifier = payload
    },
    setHasNewVersion (state, payload) {
      state.hasNewVersion = payload
    },
    setVersaoApp (state, payload) {
      state.versaoApp = payload
    },
    setNaologar (state, payload) {
      state.naologar = payload
    },
    setEmpresas (state, payload) {
      state.empresas = payload
    },
    setTotalItemsEmpresas (state, payload) {
      state.totalItemsEmpresas = payload
    },
    setConvenios (state, payload) {
      state.convenios = payload
    },
    setTotalItemsConvenios (state, payload) {
      state.totalItemsConvenios = payload
    },
    setPagamentosSecundarios (state, payload) {
      state.pagamentosSecundarios = payload
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    paginateClientes ({ commit }, payload) {
      commit('setPaginationUsuarios', payload)
    },
    verificarEmailAdministrador ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        administradorDao.verificarEmail(state.headers).then((response) => {
          if (!response.ok) {
            this.dispatch('signUserOut')
            commit('setError', {
              message: 'Você não é um administrador'
            })
          } else {
            let lastpage = localStorage.getItem(`admin-${payload.id}`)
            if (lastpage) {
              commit('setLastPage', lastpage)
            }
            commit('setUser', payload)
            this.dispatch('renovarToken')
          }
        })
      })
    },
    exportarFaturamento ({ state }, id) {
      return faturamentosDao.exportarFaturamento(id, state.headers)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'faturamento.xlsx')
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
    },
    atualizarFotoPerfil ({ commit, state }, payload) {
      commit('setLoading', true)
      let storageRef = firebase.storage().ref()
      let imageRef = storageRef.child(`users/avatars/${payload.id}.png`)
      imageRef.putString(payload.imagem, 'data_url').then((snapshot) => {
        snapshot.ref.getDownloadURL().then((downloadURL) => {
          const imagem = {
            url_imagem_perfil: downloadURL
          }
          commit('setUserImage', downloadURL)
          pessoasDao
            .atualizarImagemPerfil(imagem, state.headers)
            .then((res) => {
              commit('setLoading', false)
              if (res.ok) {
                commit('setFotoPerfil', imagem.url_imagem_perfil)
                // this.dialogConf = true
              } else {
                commit('setError', {
                  message:
                    'Não foi possível salvar a imagem de perfil do usuário'
                })
                // this.dialogImagem = true
              }
            })
        })
      })
    },
    carregarVersoes ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        versionamentoDao
          .get(payload.page, state.headers)
          .then((response) => {
            commit('setLoading', false)
            return response.json()
          })
          .then((json) => {
            commit('setVersoes', json.results)
            resolve(json)
          })
      })
    },
    excluirVersao ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        versionamentoDao
          .deleteVersion(payload.id_versao, state.headers)
          .then((response) => {
            commit('setLoading', false)
            resolve(response.state)
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    atualizarVersao ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        versionamentoDao
          .update(payload.id_versao, payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            resolve(response.state)
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    carregarPostos ({ commit, state }, payload) {
      commit('setLoading', true)
      administradorDao
        .getPostos(payload.pagination, payload.filtros, state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setPostos', json.results)
          commit('setTotalItemsPostos', json.count)
        })
    },
    detalhesPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .infoPosto(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            return response.json()
          })
          .then((json) => {
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    atualizarTudoPosto ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postoDao.atualizarPosto(
          state.headers,
          payload
        ).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            reject(Error('Não foi possível atualizar posto'))
          }
        })
      })
    },
    atualizarPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .updatePosto(payload, payload.cnpj, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              reject(response)
            }
          })
      })
    },
    carregarFormasPagamento ({ commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        formasPagDao.listFormasPagamento(payload)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        }).then((json) => {
          commit('setLoading', false)
          if (payload && payload.page) {
            commit('setFormasPag', json.results)
            commit('setTotalItemsFormasPag', json.count)
          } else {
            resolve(json)
          }
        }).catch((error) => {
          console.log(error)
          commit('setLoading', false)
          reject(
            new Error(
              'Não foi possível pegar formas de pagamento'
            )
          )
        })
      })
    },
    carregarTiposPagamento ({ commit, state }, payload) {
      commit('setLoading', true)
      tiposPagDao.get(state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setTiposPagamento', json)
        })
    },
    carregarTiposVeiculo ({ commit, state }, payload) {
      commit('setLoading', true)
      tiposVeiculoDao
        .get(state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setTiposVeiculo', json)
        })
    },
    carregarUsuarios ({ commit, state }, payload) {
      commit('setLoading', true)
      administradorDao
        .listaUsuarios(state.paginationUsuarios, payload, state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setUsuarios', json.results)
          commit('setTotalItemsUsuarios', json.count)
        })
    },
    carregarUsuariosApetrus ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        pessoasDao
          .paginated(payload.page, payload.filtros, state.headers)
          .then((response) => {
            commit('setLoading', false)
            return response.json()
          })
          .then((json) => {
            commit('setUsuariosApetrus', json.results)
            resolve(json)
          })
      })
    },
    desativarCliente ({ commit, state }, payload) {
      commit('setLoading', true)
      administradorDao
        .desativarCliente(payload.id_cliente, state.headers)
        .then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('carregarUsuarios', state.paginationUsuarios)
          } else {
            return response.error()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    ativarCliente ({ commit, state }, payload) {
      commit('setLoading', true)
      administradorDao
        .ativarCliente(payload.id_cliente, state.headers)
        .then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('carregarUsuarios', state.paginationUsuarios)
          } else {
            return response.error()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    carregarBandeiras ({ commit, state }, payload) {
      commit('setLoading', true)
      bandeiraDao
        .listBandeiras(payload, state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setBandeiras', json.results)
          commit('setTotalItemsBandeiras', json.count)
        })
    },
    carregarFaqs ({ commit, state }, payload) {
      commit('setLoading', true)
      faqDao
        .listFaqs(payload, state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setFaqs', json.results)
          commit('setTotalItemsFaqs', json.count)
        })
    },
    atualizarEnderecoPessoa ({ commit, state }, payload) {
      commit('setLoading', true)
      pessoasDao
        .atualizarEndereco(payload.cadUser, state.headers)
        .then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            commit('setEndereco', true)
          } else {
            commit('setError', {
              message: 'Não foi possível atualizar o endereço do usuário'
            })
          }
        })
    },
    carregarCombustiveis ({ commit }, payload) {
      commit('setLoading', true)
      combustivelDao
        .listCombustiveis(payload)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setCombustiveis', json)
        })
    },
    removeCombustivel ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        combustivelDao
          .removerCombustivel(payload.id_combustivel, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            } else {
              reject(response.status)
            }
          })
      })
    },
    cadastroPessoa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao
          .insert(payload.cadUser, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              return new Error('Falha ao cadastrar pessoa')
            } else {
              // this.step++
              return response.json()
            }
          })
          .then((json) => {
            commit('setPessoa', json)
            resolve(json)
          })
          .catch((error) => {
            commit('setLoading', false)
            commit('setError', error)
            reject(error)
          })
      })
    },
    cadastroTipoPagamento ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tiposPagDao
          .insert(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    atualizarTipoPagamento ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tiposPagDao
          .update(payload.id_tipo_pagamento, payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deletarTipoPagamento ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tiposPagDao
          .deletepag(payload.id_tipo_pagamento, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    cadastroTipoVeiculo ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tiposVeiculoDao
          .insert(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    atualizarTipoVeiculo ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tiposVeiculoDao
          .update(payload.id_tipo_veiculo, payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deletarTipoVeiculo ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tiposVeiculoDao
          .deleteveiculo(payload.id_tipo_veiculo, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    selectFaq ({ commit }, payload) {
      commit('setFaq', payload)
    },
    selectFormaPagamento ({ commit }, payload) {
      commit('setFormaPagamento', payload)
    },
    selectTipoPagamento ({ commit }, payload) {
      commit('setTipoPagamento', payload)
    },
    selectCombustivel ({ commit }, payload) {
      commit('setCombustivel', payload)
    },
    selectVersao ({ commit }, payload) {
      commit('setVersao', payload)
    },
    async renovarToken ({ commit, state }) {
      let diference
      var expirationTime
      var issuedAtTime
      if (state.user != null) {
        await firebase
          .auth()
          .currentUser.getIdTokenResult(true)
          .then((result) => {
            expirationTime = Date.parse(result.expirationTime)
            issuedAtTime = Date.parse(result.issuedAtTime)
            diference = (expirationTime - issuedAtTime) / 1000 / 2
            diference = diference.toFixed(0)
          })
        state.interval = setInterval(() => {
          diference--
          if (diference === 0) {
            firebase
              .auth()
              .currentUser.getIdToken(true)
              .then((token) => {
                commit('setAuthHeader', token)
              })
            firebase
              .auth()
              .currentUser.getIdTokenResult(true)
              .then((result) => {
                var expirationTime
                var issuedAtTime
                expirationTime = Date.parse(result.expirationTime)
                issuedAtTime = Date.parse(result.issuedAtTime)
                diference = (expirationTime - issuedAtTime) / 1000 / 2
                diference = diference.toFixed(0)
              })
          }
        }, 1000)
      }
    },
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((userCred) => {
          if (payload.logar) {
            const user = userCred.user
            const newUser = {
              id: user.uid,
              email: user.email,
              emailVerified: user.emailVerified,
              events: []
            }
            user.getIdToken(true).then((token) => {
              commit('setUser', newUser)
              commit('setAuthHeader', token)
            })

            firebase
              .auth()
              .currentUser.sendEmailVerification()
              .then(() => {
                commit('setLoading', false)
              })
              .catch((error) => {
                commit('setLoading', false)
                commit('setError', error)
              })
            // incluir os demais atributos que o usuário pode ter
            // Como postos que administra, perfil de cliente e perfil de frentista
          } else {
            commit('setNaologar', true)
          }
        })
        .catch((error) => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .catch((error) => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    pegarCompras ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        comprasDao
          .getCompras(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            return response.json()
          })
          .then((json) => {
            commit('setCompras', json.results.compras)
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    pegarVouchers ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao
          .get(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            return response.json()
          })
          .then((json) => {
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    signUserOut ({ commit, state }) {
      commit('setLoading', true)
      firebase
        .auth()
        .signOut()
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          console.log(errorCode)
          console.log(errorMessage)
        })
      commit('clearTimer')
      clearInterval(state.interval)
    },
    userChanged ({ commit }, payload) {
      const user = payload
      commit('setLoading', false)
      if (user) {
        let storage = firebase.storage()
        storage
          .ref(`users/avatars/${user.uid}.png`)
          .getDownloadURL()
          .then((imageUrl) => {
            commit('setUserImage', imageUrl)
          })
          .catch((error) => {
            console.log('erro', error)
          })
        const newUser = {
          id: user.uid,
          email: user.email,
          image: null,
          events: []
        }

        user.getIdToken().then((token) => {
          commit('setAuthHeader', token)
          this.dispatch('verificarEmailAdministrador', newUser)
          this.dispatch('carregarPerfil')
        })
      } else {
        commit('setUser', null)
        commit('setAuthenticated', false)
        commit('setAuthHeader', null)
        commit('setLastPage', null)
      }
      // incluir os demais atributos que o usuário pode ter
      // Como postos que administra, perfil de cliente e perfil de frentista
    },
    sendVerifyEmail ({ commit }) {
      commit('setLoading', true)
      var actionCodeSettings = {
        iOS: {
          bundleId: 'br.com.apetrus.ios'
        },
        android: {
          packageName: 'br.com.apetrus.android',
          installApp: true,
          minimumVersion: '12'
        },
        dynamicLinkDomain: 'apetrus.page.link'
      }
      firebase
        .auth()
        .currentUser.sendEmailVerification(actionCodeSettings)
        .then(() => {
          commit('setLoading', false)
        })
        .catch((error) => {
          commit('setLoading', false)
          commit('setError', error)
        })
    },
    emailCliente ({ commit, state }, email) {
      clientesDao.sendmail(email, state.headers)
    },
    inserirCliente ({ commit, state }, cliente) {
      var body = cliente.id_pessoa
        ? {
          id_pessoa: cliente.id_pessoa
        }
        : cliente
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        clientesDao
          .inserir(body, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              if (response.status === 422) {
                reject(
                  new Error('O cliente já possui um cadastro em nosso sistema')
                )
              } else {
                reject(new Error('Falha ao inserir cliente'))
              }
            }
          })
          .then((json) => {
            this.dispatch('carregarUsuarios', state.paginationUsuarios)
            resolve(json)
          })
      })
    },
    cadastroPostoByAdmin ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postoDao
          .insertByAdmin(payload.posto, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não possível cadastrar o posto.'))
            } else {
              commit('insertPosto', payload.posto)
              resolve('Posto inserido com sucesso')
            }
          })
      })
    },
    verificarEmail ({ commit, state }, email) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        clientesDao.verificarPessoa(email, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Usuário não existe'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    autenticarLogin ({ commit }) {
      commit('setAuthenticated', true)
    },
    carregarAutomacoes ({ commit, state }) {
      commit('setLoading', true)
      automacoesDao
        .list(state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setAutomacoes', json)
        })
    },
    inserirAutomacao ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        automacoesDao
          .inserir(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              throw new Error(
                'Não foi possível inserir a automação, por favor, tente novamente.'
              )
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    apagarAutomacao ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        automacoesDao
          .apagar(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              throw new Error(
                'Não foi possível apagar a automação, por favor, tente novamente.'
              )
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    inserirTermoDeUso ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        termosDeUsoDao
          .insert(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              throw new Error(
                'Não foi possível inserir o termo de uso, por favor, tente novamente.'
              )
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    loadTermoDeUso ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        termosDeUsoDao
          .list(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              throw new Error(
                'Não foi possível carregar os termos de uso, por favor, tente novamente'
              )
            }
          })
          .then((json) => {
            commit('setTermosDeUso', json.results)
            resolve(json.count)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detalhesTermoDeUso ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        termosDeUsoDao
          .info(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              throw new Error(
                'Não foi possível carregar o termo de uso, por favor, tente novamente'
              )
            }
          })
          .then((json) => {
            commit('setTermoSelected', json)
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    apagarTermoDeUso ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        termosDeUsoDao
          .deletar(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            } else {
              throw new Error(
                'Não foi possível apagar o termo de uso, por favor, tente novamente'
              )
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    inserirPoliticaDePrivacidae ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        politicasDePrivacidadeDao
          .insert(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              throw new Error(
                'Não foi possível inserir as políticas de privacidade, por favor, tente novamente.'
              )
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    loadPoliticasDePrivacidade ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        politicasDePrivacidadeDao
          .list(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              throw new Error(
                'Não foi possível carregar as políticas de privacidade, por favor, tente novamente'
              )
            }
          })
          .then((json) => {
            commit('setPoliticasDePrivacidade', json.results)
            resolve(json.count)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detalhesPoliticaDePrivacidade ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        politicasDePrivacidadeDao
          .info(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              throw new Error(
                'Não foi possível carregar as políticas de privacidade, por favor, tente novamente'
              )
            }
          })
          .then((json) => {
            commit('setPoliticaSelected', json)
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    apagarPoliticasDePrivacidade ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        politicasDePrivacidadeDao
          .deletar(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            } else {
              throw new Error(
                'Não foi possível apagar as políticas de privacidade, por favor, tente novamente'
              )
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    listPagamentosExtra ({ commit, state }) {
      commit('setLoading', true)
      pagamentosExtraDao
        .listar(state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setPagamentosExtra', json)
        })
    },
    inserirPagamentoExtra ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao
          .inserir(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve('Pagamento inserido com sucesso')
            } else {
              throw new Error('O pagamento não pode ser inserido')
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    apagarFormasPagamento ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        formasPagDao
          .deletar(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve('Pagamento apagado com sucesso')
            } else {
              throw new Error('O pagamento não pode ser apagado')
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    apagarPagamentoExtra ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao
          .deletar(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve('Pagamento apagado com sucesso')
            } else {
              throw new Error('O pagamento não pode ser apagado')
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    carregarFaturamentos ({ commit, state }, payload) {
      commit('setLoading', true)
      faturamentosDao
        .list(payload, state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setFaturamentos', json)
        })
    },
    atualizarFaturamento ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentosDao
          .update(payload.id, payload.data, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              reject(response)
            }
          })
      })
    },
    detalhesFaturamento ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentosDao
          .info(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              reject(response)
            }
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    criarCobranca ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentosDao
          .createCobranca(payload, state.headers)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else {
              throw Error('Não foi possível criar uma nova cobrança')
            }
          })
          .then((json) => {
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    atualizarCobranca ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentosDao
          .updateCobranca(payload.id, payload.data, state.headers)
          .then((response) => {
            if (response.ok) {
              resolve(response)
            } else {
              reject(Error('Não foi possível atualizar a cobrança'))
            }
          })
      })
    },
    unselectTermoPolitica ({ commit }) {
      commit('setTermoSelected', null)
      commit('setPoliticaSelected', null)
    },
    checkPedingVerifications ({ commit, state }) {
      pessoasDao
        .pending(state.headers)
        .then((response) => {
          commit('setLoading', false)
          return response.json()
        })
        .then((json) => {
          commit('setPending', json)
        })
    },
    verifyUser ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        pessoasDao
          .verifyUser(
            payload.userid,
            payload.validation,
            payload.option,
            payload.motivo,
            state.headers
          )
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(Error('Não foi possível verificar o usuário'))
            }
            return response.json()
          })
          .then((json) => {
            commit('updatePendingUser', { user: json, index: payload.index })
            resolve(json)
          })
      })
    },
    carregarPerfil ({ commit, state }) {
      pessoasDao
        .auth(state.headers)
        .then((response) => {
          return response.json()
        })
        .then((json) => {
          commit('setPessoa', json)
        })
        .catch(() => {
          commit('setError', {
            message: 'Não foi possível atualizar o endereço do usuário'
          })
        })
    },
    restoreTimer ({ commit, state }) {
      if (state.smartLock) {
        commit('setTimer', 60 * 60)
      }
    },
    addTimer ({ commit, state }) {
      if (!state.smartLock) {
        commit('setTimer', 60 * 60)
        var interval = setInterval(() => {
          if (state.timer > 0) {
            commit('decreaseTimer', 1)
          } else {
            clearInterval(interval)
          }
        }, 1000)
      }
    },
    pinAutenticar ({ commit, state }, pin) {
      return administradorDao
        .autenticarpin(pin, state.headers)
        .then((response) => {
          if (!response.ok) {
            return 'Não foi possível autenticar'
          } else {
            this.dispatch('addTimer')
            return 'ok'
          }
        })
        .catch((error) => {
          return error
        })
    },
    cadastrarpin ({ commit, state }, pin) {
      return new Promise((resolve, reject) => {
        administradorDao.cadastrarpin(pin, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error('Não foi possível cadastrar'))
          } else {
            this.dispatch('addTimer')
            resolve('ok')
          }
        })
      })
    },
    sendSmsVerification ({ commit, state }, payload) {
      commit('setLoading', true)

      commit(
        'setAppVerifier',
        new firebase.auth.RecaptchaVerifier(payload, {
          size: 'invisible'
        })
      )

      var provider = new firebase.auth.PhoneAuthProvider()
      let phoneNumber = state.pessoa.telefone.startsWith('+55')
        ? state.pessoa.telefone
        : `+55${state.pessoa.telefone}`
      return new Promise((resolve, reject) => {
        provider
          .verifyPhoneNumber(phoneNumber, state.appVerifier)
          .then((verificationId) => {
            commit('setLoading', false)
            commit('setVerificationId', verificationId)
            resolve(verificationId)
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    confirmSmsVerification ({ commit, state }, payload) {
      commit('setLoading', true)
      var phoneCredential = firebase.auth.PhoneAuthProvider.credential(
        state.verificationId,
        payload
      )
      return new Promise((resolve, reject) => {
        if (firebase.auth().currentUser.phoneNumber) {
          firebase
            .auth()
            .currentUser.reauthenticateAndRetrieveDataWithCredential(
              phoneCredential
            )
            .then((user) => {
              commit('setLoading', false)
              localStorage.setItem(`${state.user ? state.user.id : undefined}/dispositivoAutenticado`, true)
              resolve(user)
            })
            .catch((error) => {
              commit('setLoading', false)
              reject(error)
            })
        } else {
          firebase
            .auth()
            .currentUser.updatePhoneNumber(phoneCredential)
            .then(() => {
              commit('setLoading', false)
              resolve(true)
            })
            .catch((error) => {
              commit('setLoading', false)
              reject(error)
            })
        }
      })
    },
    sendWhatsappVerification ({ commit, state }) {
      commit('setLoading', true)
      const payload = {
        'celular': state.pessoa.telefone
      }
      return new Promise((resolve, reject) => {
        sendzapiDao
          .enviarCodigo(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              reject(new Error('Não foi possivel enviar o codigo'))
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    confirmWhatsappVerification ({ commit, state }, payload) {
      commit('setLoading', true)
      const codigo = {
        'codigo': payload
      }
      return new Promise((resolve, reject) => {
        sendzapiDao
          .confirmarCodigo(codigo, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              localStorage.setItem(`${state.user ? state.user.id : undefined}/dispositivoAutenticado`, true)
              resolve(true)
            } else {
              reject(new Error('Não foi possível confirmar o código do WhatsApp'))
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    enviarEmailParaUsuarios ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .enviaremail(payload, state.headers)
          .then(function (response) {
            commit('setLoading', false)
            if (response.ok) {
              resolve('ok')
            } else {
              reject(new Error(response.status))
            }
          })
      })
    },
    notificacaoPush ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        notificacaoDao.post(payload, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error('Não foi possível enviar notificação'))
          } else {
            resolve('Notificacao enviada com sucesso.')
          }
        })
      })
    },
    frentistaPosto ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postoDao.frentistasDoPosto(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Ocorreu um erro'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    pagarFrentista ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao.pagarFrentista(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Ocorreu um erro'))
          } else {
            resolve('Pagamento executado com sucesso')
          }
        })
      })
    },
    getSolicitacoes ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postoDao.getSolicitacoes(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Ocorreu um erro'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    verificarAtualizacao ({ commit }, payload) {
      var version = localStorage.getItem(`${payload.name}-versao`)
      if (version !== payload.version) {
        commit('setHasNewVersion', true)
      }
    },
    atualizarVersaoApp ({ commit }, payload) {
      localStorage.setItem(`${payload.name}-versao`, payload.version)
      commit('setVersaoApp', payload.version)
    },
    trocarOuEditarRepresentate ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        postoDao.TrocarOuEditar(payload, state.headers).then((response) => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível editar representante'))
          }
        })
      })
    },
    setNaologar ({ commit }, payload) {
      commit('setNaologar', payload)
    },
    gerarFaturamento ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        faturamentosDao
          .gerarFaturamento(payload, state.headers)
          .then((response) => {
            if (response.ok) {
              resolve('ok')
            } else {
              reject(new Error('Não foi possível gerar faturamento'))
            }
          })
      })
    },
    getEmpresas ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .getEmpresas(payload.pagination, payload.filtros, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Ocorreu um erro'))
            } else {
              return response.json()
            }
          })
          .then((json) => {
            commit('setEmpresas', json.results)
            commit('setTotalItemsEmpresas', json.count)
            resolve(json.results)
          })
      })
    },
    ativarOuDesativarEmpresa ({ state }, payload) {
      return new Promise((resolve, reject) => {
        empresaDao
          .ativarOuDesativar(state.headers, payload)
          .then((response) => {
            if (response.ok) {
              resolve('ok')
            } else {
              reject(new Error('Não foi possível realizar operação'))
            }
          })
      })
    },
    editarConvenios ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        convenioDao
          .editarConvenio(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Ocorreu um erro'))
            } else {
              resolve('ok')
            }
          })
      })
    },
    getConvenios ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        convenioDao
          .getAll(state.headers, payload.filtros, payload.page)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Ocorreu um erro'))
            } else {
              return response.json()
            }
          })
          .then((json) => {
            if (payload.filtros.notificado === undefined) {
              commit('setConvenios', json.results)
              commit('setTotalItemsConvenios', json.count)
            }
            resolve(json.results)
          })
      })
    },
    ativarOuDesativarConvenio ({ state }, payload) {
      return new Promise((resolve, reject) => {
        convenioDao
          .ativarOuDesativar(state.headers, payload)
          .then((response) => {
            if (response.ok) {
              resolve('ok')
            } else {
              reject(new Error('Não foi possível realizar operação'))
            }
          })
      })
    },
    estornarDinheiro ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        cartaoDao.estornar(id, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', 'Não foi possível estortar cartão')
            reject(new Error('Não foi possível estortar cartão'))
          } else {
            resolve('ok')
          }
        })
      })
    },
    cancelarEstorno ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        cartaoDao.cancelarEstorno(id, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', 'Não foi possível cancelar estorto')
            reject(new Error('Não foi possível cancelar estorto'))
          } else {
            resolve('ok')
          }
        })
      })
    },
    pegarLimite ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        comprasDao.pegarLimite(state.headers, payload).then((res) => {
          commit('setLoading', false)
          if (!res.ok) {
            reject(new Error('Não foi possível pegar limite de compra'))
          }
          resolve(res.json())
        })
      })
    },
    definirLimite ({ state }, payload) {
      return new Promise((resolve, reject) => {
        comprasDao.definirLimite(payload, state.headers).then((res) => {
          if (!res.ok) {
            reject(new Error('Não foi possível definir limite de compra'))
          }
          resolve('Ok')
        })
      })
    },
    deletarLimite ({ state, commit }, payload) {
      // Deleta o limite da compra ou limite de combustivel
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        comprasDao.deletarLimite(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível deletar limite'))
          }
          resolve('Ok')
        })
      })
    },
    comprasParaEstornar ({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        cartaoDao
          .comprasParaEstornar(state.headers)
          .then((response) => response.json())
          .then((json) => {
            commit('setLoading', false)
            resolve(json)
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    pegarCodigosPromocionais ({ commit, state }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        codigosPromocionaisDao
          .PegarCodigos(state.headers)
          .then((res) => {
            if (!res.ok) {
              reject(new Error('Erro ao carregar códigos'))
            }
            return res.json()
          })
          .then((json) => {
            commit('setLoading', false)
            resolve(json)
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    inserirCodigoPromocional ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        codigosPromocionaisDao
          .inserir(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              throw Error()
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    cancelarCodigo ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        codigosPromocionaisDao
          .cancelar(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              commit('setLoading', false)
              resolve(response)
            } else {
              throw Error()
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    atualizarBannerCodigoPromocional ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        let storageRef = firebase.storage().ref()
        let imageRef = storageRef.child(
          `admin/${payload.codigo}/banners/codigo_${payload.codigo}.png`
        )
        imageRef.putString(payload.imagem, 'data_url').then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            const data = {
              url_imagem_codigo: downloadURL
            }
            codigosPromocionaisDao
              .atualizar(payload.codigo, data, state.headers)
              .then((res) => {
                commit('setLoading', false)
                if (!res.ok) {
                  commit('setError', {
                    message: 'Não foi possível salvar o banner do código'
                  })
                  reject(
                    new Error('Não foi possível salvar o banner do código')
                  )
                }
                commit('setLoading', false)
                resolve(downloadURL)
              })
          })
        })
      })
    },
    pegarTodosPostos ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao
          .pegarTodos(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar postos'))
            }
            return response.json()
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    pegarTodasRedes ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeDao
          .pegarTodas(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar redes'))
            }
            return response.json()
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    pegarRedes ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeDao
          .get(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar redes'))
            }
            return response.json()
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    deletarRede ({ state }, id) {
      return new Promise((resolve, reject) => {
        redeDao.deletarRede(state.headers, id).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível deletar rede.'))
          }
        })
      })
    },
    vinculoCodigoPropocional ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        codigosPromocionaisDao
          .vinculo(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve('OK')
          })
      })
    },
    influenciador ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        clientesDao.influenciador(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    pegarInfluenciador ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        clientesDao
          .pegarInfluenciador(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    pegarCarteiraVirtual ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        carteiraVirtualDao.pegarCarteiraVirtual(
          state.headers,
          payload
        ).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar carteira virtual'))
          }
          resolve(response.json())
        })
      })
    },
    pegarHistoricoDaCarteiraVirtual ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        carteiraVirtualDao.pegarHistorico(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar histórico da carteira.'))
            }
            resolve(response.json())
          })
      })
    },
    solicitacoesRetirada ({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        clientesDao.solicitacoesRetirada(state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve(response.json())
        })
      })
    },
    marcarComoPago ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        clientesDao.marcarComoPago(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    pegarBloqueios ({ state, commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.pegarBoqueios(state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pégar bloqueios'))
          }
          resolve(response.json())
        })
      })
    },
    marcarComoVisto ({ state, commit }, payload) {
      // Marca o bloqueio como visto
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.marcarComoVisto(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve('OK')
        })
      })
    },
    editarEmpresa ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.editarEmpresa(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve('OK')
        })
      })
    },
    pegarEmpresa ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.pegarEmpresa(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve(response.json())
        })
      })
    },
    atualizarPessoa ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .atualizarPessoa(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível realizar operação'))
            }
            resolve('OK')
          })
      })
    },
    pegarNovosContratos ({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        administradorDao.pegarNovosContratos(state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve(response.json())
        })
      })
    },
    marcarComoLido ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        administradorDao
          .marcarComoLido(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível realizar operação'))
            }
            resolve('OK')
          })
      })
    },
    cancelarCompra ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        comprasDao.cancelarCompra(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve('OK')
        })
      })
    },
    desativarVoucher ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        voucherDao.cancelarVoucher(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve('OK')
        })
      })
    },
    dadosFatura ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        faturamentosDao
          .dadosFaturamento(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar dados da fatura.'))
            }
            resolve(response.json())
          })
      })
    },
    meioRecebimentoApetrus ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE e POST
      */
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .meioRecebimentoApetrus(state.headers, payload, payload.method)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) reject(new Error('Não foi possível realizar cadastro'))
            if (payload.method === 'GET') resolve(response.json())
            resolve('OK')
          })
      })
    },
    adicaoDeCredito ({ commit, state }, payload) {
      /*
        Usada para GET e PUT
      */
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        carteiraVirtualDao
          .adicaoDeCredito(state.headers, payload.method, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) reject(new Error('Não foi possível realizar operação'))
            if (payload.method === 'GET') resolve(response.json())
            resolve('OK')
          })
      })
    },
    propostasApetrus ({ commit, state }, payload) {
      /*
        Usada para GET e PUT
      */
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        propostaDao
          .propostasApetrus(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível realizar operação'))
            }
            if (payload.method === 'GET') resolve(response.json())
            resolve('OK')
          })
      })
    },
    pegarCarteiraVirtualAdm ({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        carteiraVirtualDao
          .pegarCarteiraVirtualAdm(state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    pegarHistoricoDaCarteiraVirtualAdm ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        administradorDao
          .pegarHistoricoDaCarteiraVirtualAdm(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    procurarPessoasPorAdm ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        pessoasDao
          .procurarPessoasPorAdm(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    procurarEmpresasPorAdmTransferencia ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        empresaDao
          .procurarEmpresasPorAdmTransferencia(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    procurarEmpresasPorAdm ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        empresaDao
          .procurarEmpresasPorAdm(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    procurarPostosPorAdm ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao
          .procurarPostosPorAdm(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    procurarPostosPorUsuario ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao
          .procurarPostosPorUsuario(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    procurarEmpresasPorUsuario ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        empresaDao
          .procurarEmpresasPorUsuario(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    transferirSaldo ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        administradorDao
          .transferirSaldo(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve('OK')
            } else {
              reject(new Error('Ocorreu um erro ao transferir saldo'))
            }
          })
      })
    },
    contratoEmpresa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        configuracoesDao
          .ContratoEmpresa(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível realizar operação'))
            }
            if (payload.method === 'GET') resolve(response.json())
            resolve('OK')
          })
      })
    },
    contratoPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        configuracoesDao
          .ContratoPosto(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível realizar operação'))
            }
            if (payload.method === 'GET') resolve(response.json())
            resolve('OK')
          })
      })
    },
    notificacoesAdmin ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        notificacaoDao.getAndPut(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          if (payload.method === 'GET') resolve(response.json())
          resolve('OK')
        })
      })
    },
    cadSmartLockPessoa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.cadSmartLock(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro no cadastro.'))
          }
        })
      })
    },
    updatePessoa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.updatePessoa(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro ao atualizar essa pessoa.'))
          }
        })
      })
    },
    apagarPessoa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.apagarPessoa(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro ao apagar essa pessoa.'))
          }
        })
      })
    },
    versaoApp ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        configuracoesDao.versaoApp(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          if (payload.method === 'GET') resolve(response.json())
          resolve('OK')
        })
      })
    },
    cadastrarEmpresa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.cadastrar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Não foi possível realizar cadastro.'))
          }
        })
      })
    },
    tornarParceira ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.tornarParceira(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Não foi possível realizar operação.'))
          }
        })
      })
    },
    BloquearUsuario ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.BloquearUsuario(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Não foi possível realizar operação.'))
          }
        })
      })
    },
    inserirArquivoFirebase ({ commit, state }, payload) {
      // Esse função tem a responsabilidade de inserir qualquer aquivo no firebase
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        let storageRef = firebase.storage().ref()
        let imageRef = storageRef.child(
          `${payload.rota}/${payload.local}/${payload.id}.${payload.tipo}`
        )
        imageRef.putString(payload.arquivo, 'data_url').then((snapshot) => {
          commit('setLoading', false)
          snapshot.ref
            .getDownloadURL()
            .then((downloadURL) => {
              resolve(downloadURL)
            })
            .catch((error) => {
              reject(error)
            })
        })
      })
    },
    pegarVeiculos ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        veiculoDao.list(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve(response.json())
        })
      })
    },
    pegarClientes ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        clientesDao
          .clientesFiltrados(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Algo deu errado'))
            }
            resolve(response.json())
          })
      })
    },
    pegarFuncionarios ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        funcionarioDao.filtrar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve(response.json())
        })
      })
    },
    editarVeiculo ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        veiculoDao.editar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    automacaoEmpresa ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        empresaDao.automacaoEmpresa(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    atualizarTudoRede ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeDao.atualizar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    transferirPosto ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao.transferirPosto(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    solicitacoes ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        solicitacaoDao.list(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve(response.json())
        })
      })
    },
    solicitacao ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        solicitacaoDao.multipleMethods(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          if (payload.method === 'GET') resolve(response.json())
          resolve('ok')
        })
      })
    },
    cadastrarUsuarioFrentista ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.cadastrarUsuarioFrentista(
          state.headers,
          payload
        ).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error(response.text))
          }
          resolve(response.json())
        })
      })
    },
    inserirFrentista ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.inserirFrentista(
          state.headers,
          payload
        ).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error(response.text))
          }
          resolve(response.json())
        })
      })
    },
    removerFrentista ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.inativarFrentista(
          state.headers,
          payload
        ).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error(response.text))
          }
          resolve('ok')
        })
      })
    },
    editarFrentista ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.put(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível editar frentistas'))
          }
        })
      })
    },
    consultarFrentistaCPF ({ commit, state }, cpf) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.verificarPessoa(cpf, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Usuário não existe'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    frentistas ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.get(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Não foi possível pegar frentistas'))
          }
        })
      })
    },
    verificarTelefone ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.verificarTelefone(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Algo deu errado'))
          }
        })
      })
    },
    desvincularPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao.desvincularPagamento(
          state.headers,
          payload
        ).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('listPagamentosExtra')
            this.dispatch('carregarPagamentosSecundarios')
            resolve('Forma de pagamento apagada com sucesso.')
          } else {
            throw new Error('Desculpe, mas a forma de pagamento não pôde ser apagada.')
          }
        }).catch(error => {
          commit('setLoading', false)
          reject(error)
        })
      })
    },
    vincularPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao.vincularPagamento(
          state.headers,
          payload
        ).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('listPagamentosExtra')
            this.dispatch('carregarPagamentosSecundarios')
            resolve('Forma de pagamento vinculada com sucesso.')
          } else {
            throw new Error('Desculpe, mas a forma de pagamento não pôde ser vinculada.')
          }
        }).catch(error => {
          commit('setLoading', false)
          reject(error)
        })
      })
    },
    carregarPagamentosSecundarios ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao.listarSecundarios(state.headers).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          commit('setPagamentosSecundarios', json)
          resolve(json)
        }).catch(error => {
          commit('setLoading', false)
          reject(error)
        })
      })
    },
    habilitarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao.habilitarPagamento(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('listPagamentosExtra')
            this.dispatch('carregarPagamentosSecundarios')
            resolve(response)
          } else {
            reject(response)
          }
        })
      })
    },
    ativarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao.ativarPagamento(
          state.headers,
          payload
        ).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('listPagamentosExtra')
            this.dispatch('carregarPagamentosSecundarios')
            resolve(response)
          } else {
            reject(response)
          }
        })
      })
    },
    atualizarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtraDao.atualizar(
          state.headers,
          payload
        ).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('listPagamentosExtra')
            this.dispatch('carregarPagamentosSecundarios')
            resolve('Ok')
          } else {
            reject(new Error('Não foi possível atualizar o meio de pagamento'))
          }
        })
      })
    },
    async pegarCoordenadas ({ commit }, payload) {
      commit('setLoading', true)
      const response = await coordenadas.getCoordenadas(
        payload.logradouro,
        payload.numero,
        payload.bairro,
        payload.cidade,
        payload.estado
      )
      commit('setLoading', false)
      if (!response.ok) {
        const retorno = await this.dispatch('pegarCoordenadasGoogle', payload)
        return retorno
      }

      const json = await response.json()
      commit('setLoading', false)
      if (json.length === 0) {
        const retorno = await this.dispatch('pegarCoordenadasGoogle', payload)
        return retorno
      }
      if (payload.retornar_tudo) {
        return json
      }
      return {
        latitude: json[0].lat,
        longitude: json[0].lon
      }
    },
    pegarCoordenadasGoogle ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        coordenadas.getCoordenadasGoogle(
          payload.logradouro,
          payload.numero,
          payload.bairro,
          payload.cidade,
          payload.estado
        ).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar coordenadas'))
          }
          return response.json()
        }).then(json => {
          commit('setLoading', false)
          if (json.results.length === 0) {
            reject(new Error('Não foi possível pegar coordenadas'))
          }
          if (payload.retornar_tudo) {
            resolve(json.results)
          }
          resolve({
            latitude: json.results[0].geometry.location.lat,
            longitude: json.results[0].geometry.location.lng
          })
        }).catch((e) => {
          console.log(e)
          commit('setLoading', false)
          reject(new Error('Não foi possível pegar coordenadas'))
        })
      })
    },
    deletarArquivoFirebase ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const storageRef = firebase.storage().refFromURL(payload).delete()
        storageRef.then(() => {
          resolve('Arquivo deletado com sucesso!')
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    anuncios ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        anuncioDao
          .anuncio(state.headers, payload.body, payload.method, payload.id)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) reject(new Error('Não foi possível realizar cadastro'))
            if (payload.method === 'DELETE') {
              if (payload.body.imagens.length > 0) {
                payload.body.imagens.map(imagem => {
                  this.dispatch('deletarArquivoFirebase', imagem)
                })
              }
            }
            resolve(response.json())
          })
      })
    },
    categorias ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        categoriaDao
          .categoria(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Não foi possível pegar categorias'))
              else if (payload.method === 'POST') reject(new Error('Não foi possível cadastrar categoria'))
              else if (payload.method === 'PUT') reject(new Error('Não foi possível atualizar categoria'))
              else if (payload.method === 'DELETE') reject(new Error('Não foi possível desativar categoria'))
            }
            if (payload.method === 'GET') resolve(response.json())
            resolve('ok')
          })
      })
    },
    pegarCarteirasVirtuais ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        carteiraVirtualDao.todas(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Algo deu errado'))
          }
        })
      })
    },
    projetosFirebase ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */

      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        firebaseDao
          .gerenciar(state.headers, payload.body, payload.method, payload.id)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) reject(new Error('Não foi possível realizar cadastro'))
            if (payload.method !== 'DELETE') resolve(response.json())
            resolve('OK')
          })
      })
    },
    gerenciarBandeiras ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */

      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        bandeiraCartaoDao.gerenciar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) reject(new Error('Não foi possível realizar cadastro'))
          if (payload.method !== 'DELETE') resolve(response.json())
          resolve('OK')
        })
      })
    },
    integrador ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        integradorDao.gerenciar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) reject(new Error('Não foi possível realizar cadastro'))
          // if (payload.method !== 'DELETE') resolve(response.json())
          resolve('OK')
        })
      })
    },
    pegarPostosPorRede ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeDao
          .postosDaRede(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar redes'))
            }
            resolve(response.json())
          })
      })
    },
    cadastrarRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redeDao.cadastrar(state.headers, payload).then(response => {
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Não foi possível cadastrar rede'))
          }
        })
      })
    },
    inserirEmRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redeDao.inserirEmRede(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível inserir postos na rede'))
          }
        })
      })
    },
    inserirPostoMatriz ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redeDao.postoMatriz(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível inserir postos na rede'))
          }
        })
      })
    },
    removerDaRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redeDao.removerDaRede(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('Inserido com sucesso')
          }
          return response.text()
        }).then(error => {
          reject(error)
        })
      })
    },
    postosSemRede ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redeDao.postosSemRede(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
        }).catch(() => {
          commit('setLoading', false)
          reject(new Error('Não foi possível pegar redes'))
        })
      })
    },
    pegarPessoaPorId ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.pegarPorId(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar pessoa.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    opcionaisVeiculo ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        veiculoDao.opcionais(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) reject(new Error('Não foi possível realizar operação'))
          if (payload.method === 'GET') resolve(response.json())
          resolve('OK')
        })
      })
    },
    leilaoVeiculos ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        leilaoDao
          .multMethods(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Não foi possível pegar leilões'))
              else if (payload.method === 'POST') {
                commit('setErrot', 'Não foi possível cadastrar leilão')
                reject(new Error('Não foi possível cadastrar leilão'))
              } else if (payload.method === 'PUT') {
                commit('setErrot', 'Não foi possível atualizar leilão')
                reject(new Error('Não foi possível atualizar leilão'))
              } else if (payload.method === 'DELETE') {
                commit('setErrot', 'Não foi possível apagar leilão')
                reject(new Error('Não foi possível apagar leilão'))
              }
            }
            if (payload.method === 'DELETE') resolve('ok')
            else {
              resolve(response.json())
            }
          })
      })
    },
    lancesLeilao ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        leilaoDao
          .lances(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Não foi possível pegar lances'))
              else if (payload.method === 'POST') {
                commit('setErrot', 'Não foi possível cadastrar lance')
                reject(new Error('Não foi possível cadastrar lance'))
              } else if (payload.method === 'PUT') {
                commit('setErrot', 'Não foi possível atualizar lance')
                reject(new Error('Não foi possível atualizar lance'))
              } else if (payload.method === 'DELETE') {
                commit('setErrot', 'Não foi possível apagar lance')
                reject(new Error('Não foi possível apagar lance'))
              }
            }
            if (payload.method === 'GET') resolve(response.json())
            else {
              if (payload.method === 'DELETE') commit('setSuccess', 'O lance foi cancelado com sucesso')
              else if (payload.method === 'POST') commit('setSuccess', 'O lance foi realizado com sucesso')
              else if (payload.method === 'PUT') commit('setSuccess', 'O lance foi alterado com sucesso')
              resolve('ok')
            }
          })
      })
    },
    gerenciarFaturas ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        faturamentosDao
          .gerenciar(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Não foi possível pegar faturas'))
              else if (payload.method === 'POST') {
                commit('setErrot', 'Não foi possível cadastrar fatura')
                reject(new Error('Não foi possível cadastrar fatura'))
              } else if (payload.method === 'PUT') {
                commit('setErrot', 'Não foi possível atualizar fatura')
                reject(new Error('Não foi possível atualizar fatura'))
              } else if (payload.method === 'DELETE') {
                commit('setErrot', 'Não foi possível apagar fatura')
                reject(new Error('Não foi possível apagar fatura'))
              }
            }
            if (payload.method === 'GET') resolve(response.json())
            else {
              if (payload.method === 'DELETE') commit('setSuccess', 'O fatura foi cancelada com sucesso')
              else if (payload.method === 'POST') commit('setSuccess', 'O fatura foi cadastrada com sucesso')
              else if (payload.method === 'PUT') commit('setSuccess', 'O fatura foi alterada com sucesso')
              resolve('ok')
            }
          })
      })
    },
    pegarPrecos ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        precoCombustivelDao.pegarPorPosto(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar preços.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    sendZapi ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        sendzapiDao
          .conexao(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Conexão já existente'))
              else if (payload.method === 'PUT') {
                commit('setErrot', 'Não foi possível atualizar informações')
                reject(new Error('Não foi possível atualizar informações'))
              } else if (payload.method === 'DELETE') {
                commit('setErrot', 'Não foi possível cancelar conexão')
                reject(new Error('Não foi possível cancelar conexão'))
              }
            }
            if (payload.method === 'GET') resolve(response.json())
            else {
              if (payload.method === 'DELETE') commit('setSuccess', 'A conexão existente foi finalizada com sucesso')
              else if (payload.method === 'PUT') commit('setSuccess', 'A conexão foi estabelecida com sucesso')
              resolve('ok')
            }
          })
      })
    },
    criarTaxaChecktudo ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        taxasChecktudoDao.criarTaxa(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            } else {
              reject(new Error('Erro ao criar taxa'))
            }
          })
      })
    },
    atualizarTaxaChecktudo ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        taxasChecktudoDao.atualizarTaxa(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.status)
            } else {
              reject(new Error('Erro ao atualizar taxa'))
            }
          })
      })
    },
    listarTaxasChecktudo ({ state, commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        taxasChecktudoDao.listarTaxas(state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              reject(new Error('Erro ao listar taxas'))
            }
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    pegarAssinaturas ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        assinaturaDao.pegar(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              reject(new Error('Não foi posssível pegar assinaturas'))
            }
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    pegarPedidos ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pedidoDao.get(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.json())
            } else {
              reject(new Error('Não foi posssível pegar pedidos'))
            }
          })
      })
    },
    exportarClientesPorProjeto ({ state }, projeto) {
      return new Promise((resolve, reject) => {
        administradorDao.exportarClientePorProjeto(state.headers, { projeto })
          .then(response => {
            if (response.ok) {
              return response.blob()
            } else {
              reject(new Error('Erro ao exportar clientes'))
            }
          })
          .then(blob => {
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'clientes_projeto.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
            resolve()
          })
          .catch(err => reject(err))
      })
    },
    VincularSincicato ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.vincularSindicato(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve('OK')
            } else {
              reject(new Error('Não foi posssível vincular sindicato'))
            }
          })
      })
    },
    transferirInformacoesDoPosto ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao.transferirInformacoes(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve('OK')
            } else {
              reject(new Error('Não foi posssível transferir informações'))
            }
          })
      })
    },
    pegarPostoPorCNPJ ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postoDao.getByAdmin(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.json())
            } else {
              reject(new Error('Não foi posssível pegar o posto'))
            }
          })
      })
    },
    pegarTodasRedesEmpresas ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeEmpresaDao
          .todasRedeEmpresas(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar redes'))
            }
            return response.json()
          })
          .then((json) => {
            resolve(json)
          })
      })
    },
    cadastrarRedeEmpresa ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redeEmpresaDao.cadastrarRedeEmpresa(state.headers, payload).then(response => {
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Não foi possível cadastrar rede'))
          }
        })
      })
    },
    atualizarRedeEmpresa ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeEmpresaDao.atualizarRedeEmpresa(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve('OK')
        })
      })
    },
    EmpresasSemRede ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redeEmpresaDao.EmpresasSemRede(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
        }).catch(() => {
          commit('setLoading', false)
          reject(new Error('Não foi possível pegar redes'))
        })
      })
    },
    pegarEmpresasPorRede ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        redeEmpresaDao.EmpresasDaRede(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar empresas da rede'))
            }
            resolve(response.json())
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    inserirEmRedeEmpresa ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redeEmpresaDao.inserirEmRedeEmpresa(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível inserir postos na rede'))
          }
        })
      })
    },
    deletarRedeEmpresa ({ state }, id) {
      return new Promise((resolve, reject) => {
        redeEmpresaDao.deletarRedeEmpresa(state.headers, id).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível deletar rede.'))
          }
        })
      })
    }
  },
  getters: {
    headers (state) {
      return state.headers
    },
    user (state) {
      return state.user
    },
    pessoa (state) {
      return state.pessoa
    },
    postos (state) {
      return state.postos
    },
    totalItemsPostos (state) {
      return state.totalItemsPostos
    },
    usuarios (state) {
      return state.usuarios
    },
    usuariosApetrus (state) {
      return state.usuariosApetrus
    },
    totalItemsUsuarios (state) {
      return state.totalItemsUsuarios
    },
    compras (state) {
      return state.compras
    },
    formaPagamento (state) {
      return state.formaPagamento
    },
    formasPag (state) {
      return state.formasPag
    },
    totalItemsFormasPag (state) {
      return state.totalItemsFormasPag
    },
    tiposPag (state) {
      return state.tiposPag
    },
    tipoPag (state) {
      return state.tipoPag
    },
    bandeiras (state) {
      return state.bandeiras
    },
    tiposVeiculo (state) {
      return state.tiposVeiculo
    },
    totalItemsBandeiras (state) {
      return state.totalItemsBandeiras
    },
    combustiveis (state) {
      return state.combustiveis
    },
    combustivel (state) {
      return state.combustivel
    },
    faqs (state) {
      return state.faqs
    },
    faq (state) {
      return state.faq
    },
    totalItemsFaqs (state) {
      return state.totalItemsFaqs
    },
    versoes (state) {
      return state.versoes
    },
    versao (state) {
      return state.versao
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    endereco (state) {
      return state.endereco
    },
    fotoPerfil (state) {
      return state.fotoPerfil
    },
    isUserVerified () {
      let user = firebase.auth().currentUser
      if (user) {
        return user.emailVerified
      } else {
        return null
      }
    },
    authenticated (state) {
      return state.authenticated
    },
    lastPage (state) {
      return state.lastPage
    },
    automacoes (state) {
      return state.automacoes
    },
    termosDeUso (state) {
      return state.termosDeUso
    },
    politicasDePrivacidade (state) {
      return state.politicasDePrivacidade
    },
    termoSelected (state) {
      return state.termoSelected
    },
    politicaSelected (state) {
      return state.politicaSelected
    },
    pagamentosExtra (state) {
      return state.pagamentosExtra
    },
    faturamentos (state) {
      return state.faturamentos
    },
    pendingUsers (state) {
      return state.pendingUsers
    },
    smartLock (state) {
      return state.smartLock
    },
    timer (state) {
      return state.timer
    },
    paginationUsuarios (state) {
      return state.paginationUsuarios
    },
    hasNewVersion (state) {
      return state.hasNewVersion
    },
    versaoApp (state) {
      return state.versaoApp
    },
    naologar (state) {
      return state.naologar
    },
    empresas (state) {
      return state.empresas
    },
    totalItemsEmpresas (state) {
      return state.totalItemsEmpresas
    },
    convenios (state) {
      return state.convenios
    },
    totalItemsConvenios (state) {
      return state.totalItemsConvenios
    },
    pagamentosSecundarios (state) {
      return state.pagamentosSecundarios
    },
    estados (state) {
      return state.estados
    }
  }
})
